import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {AnalysisResultCategoriesActions} from '../store';
import {AnalysisResultCategoriesSelectors} from '../store/selectors';
import {ApplicationState} from '../../application-state/store';

@Injectable()
export class AnalysisResultCategoriesLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadAnalysisResultCategoriesDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadAnalysisResultCategoriesDone() {

    return this.store.pipe(
      select(AnalysisResultCategoriesSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(AnalysisResultCategoriesActions.ReadAnalysisResultCategories());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
